import React from 'react'

interface ReviewStarsProps {
    rating: number
    // Glyph font-size in px (design uses 14 in the list, 18 in the summary).
    size?: number
    className?: string
}

// Star display using the ★ glyph (U+2605) so letter-spacing stays crisp, matching
// the handoff: filled stars in Kibu orange, empties in #E0DDD6.
const ReviewStars: React.FC<ReviewStarsProps> = ({ rating, size = 14, className = '' }) => {
    const filled = Math.max(0, Math.min(5, Math.round(rating)))
    const empty = 5 - filled

    return (
        <span
            className={className}
            style={{ fontSize: `${size}px`, letterSpacing: '1px', whiteSpace: 'nowrap', lineHeight: 1 }}
            aria-label={`${filled} out of 5 stars`}
            role="img"
        >
            <span style={{ color: '#FF784D' }}>{'★'.repeat(filled)}</span>
            <span style={{ color: '#E0DDD6' }}>{'★'.repeat(empty)}</span>
        </span>
    )
}

export default ReviewStars
